import { useContext } from 'react';
import CartMutationContext from './CartMutationContext';

export default function useCartMutator() {
  return useContext(CartMutationContext);
}
